import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const EnableIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="EnableIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/enable">
            <path
                d="M5 4.83167C5 4.0405 5.87525 3.56266 6.54076 3.99049L17.6915 11.1588C18.3038 11.5525 18.3038 12.4475 17.6915 12.8412L6.54076 20.0095C5.87525 20.4373 5 19.9595 5 19.1683V4.83167Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </g>
    </SvgIcon>
)
